import React, { useState, useEffect, useRef } from 'react';
import { FaDiscord } from 'react-icons/fa';
import './SocialsSection.css';

// Custom X (Twitter) Icon Component
const XIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" style={{ width: '1em', height: '1em', fill: 'currentColor' }}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const SocialsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const currentSection = sectionRef.current;

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  const socialLinks = [
    {
      name: 'X (Twitter)',
      url: 'https://x.com/angryaliensally?s=21',
      icon: <XIcon />
    },
    {
      name: 'Discord',
      url: 'https://discord.com/invite/yTu6An3jQC',
      icon: <FaDiscord />
    }
  ];

  const title = "SOCIALS";

  return (
    <section className="socials-section" ref={sectionRef}>
      <h2 className={`socials-title ${isVisible ? 'visible' : ''}`}>
        {title.split('').map((char, idx) => (
          <span
            key={idx}
            className="title-letter"
            style={{ animationDelay: `${idx * 0.1}s` }}
          >
            {char}
          </span>
        ))}
      </h2>
      
      <div className="socials-container">
        {socialLinks.map((social, index) => (
          <a 
            key={index}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`social-link ${isVisible ? 'visible' : ''}`}
            style={{ animationDelay: `${0.3 + index * 0.15}s` }}
          >
            <span className="social-icon">{social.icon}</span>
            <span className="social-name">{social.name}</span>
          </a>
        ))}
      </div>

      <div className={`footer ${isVisible ? 'visible' : ''}`}>
        <p>© {new Date().getFullYear()} Angry Aliens Alliance. All rights reserved.</p>
      </div>

      <div className={`alien-standing ${isVisible ? 'visible' : ''}`}>
        <img 
          src={require('../images/alienbody.webp')} 
          alt="Standing Alien" 
          className="alien-body"
        />
      </div>
    </section>
  );
};

export default SocialsSection;